import Link from "next/link";

import Button from "@/components/atoms/Button";
import { CallToActionParagraphFieldsFragment } from "@/graphql/sdk/__generated__";
import { cn } from "@/helpers/className";
import Sprite from "../atoms/Sprite";

interface CallToActionParagraphProps {
  className?: string;
  data: CallToActionParagraphFieldsFragment;
  narrow?: boolean;
}

export const CallToActionParagraph = ({
  data,
  className,
  narrow,
}: CallToActionParagraphProps) => {
  const bgColor = data.entity_type_behaviors.background_color || "yellow";
  const box_display = data.entity_type_behaviors.box_display === "1";
  const containerClass = box_display ? "container" : "";
  const mapBgColor = {
    green: "bg-green-300",
    yellow: "bg-yellow-600",
    orange: "bg-orange",
    white: "bg-white",
    lightYellow: "bg-yellow",
    lightMint: "bg-green-100",
    grey: "bg-gray",
    stroke: "bg-border",
    mint: "bg-green-300",
    darkGreen: "bg-green-600",
  };

  return (
    <div className={cn("paragraph--cta", containerClass, className)}>
      <div className="grid grid-cols-12">
        <div
          className={cn(
            "cta relative col-span-12 flex flex-col items-start justify-end overflow-hidden bg-no-repeat px-8 py-12 transition duration-500 lg:min-h-[384px] lg:p-16",
            mapBgColor[bgColor],
            box_display && !narrow
              ? "rounded-2xl lg:col-span-10 lg:col-start-2"
              : "",
            box_display && narrow
              ? "rounded-2xl lg:!min-h-[auto] xl:col-span-8 xl:col-start-3 2xl:col-span-6 2xl:col-start-4"
              : "",
            className == "rounded" && !narrow && !box_display
              ? "rounded-2xl"
              : "",
          )}
        >
          <div className={cn("relative z-1", !box_display ? "container" : "")}>
            {data.label && (
              <div className="caption text-green">{data?.label}</div>
            )}

            {data.title && <h2>{data.title}</h2>}

            {data?.paragraphCallToActionText && (
              <div
                className="prose mb-8 text-lg font-medium text-black-400"
                dangerouslySetInnerHTML={{
                  __html: data.paragraphCallToActionText.processed ?? "",
                }}
              ></div>
            )}

            <div className="mt-8 flex flex-wrap items-center gap-6 lg:mt-12 lg:gap-8">
              {data?.paragraphCallToActionLink && (
                <Button
                  as="link"
                  className="btn-lg"
                  href={String(data.paragraphCallToActionLink.url)}
                >
                  {data.paragraphCallToActionLink.title}
                </Button>
              )}
              {data?.paragraphCallToActionLink2 && (
                <Link
                  className="link"
                  key={data.paragraphCallToActionLink2.url}
                  href={String(data.paragraphCallToActionLink2.url)}
                >
                  {data.paragraphCallToActionLink2.title}
                </Link>
              )}
            </div>
          </div>

          <Sprite className="cta__sprite bottom-[-484px] right-0 h-[1205px] w-[913px] translate-x-[600px] xl:translate-x-[456px]" />
        </div>
      </div>
    </div>
  );
};
